import { defineComponent as _defineComponent } from 'vue';
import { ComboboxPortal, ComboboxContent, ComboboxViewport } from 'reka-ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ComboboxContent',
    props: {
        sideOffset: { type: Number, required: false, default: 10 }
    },
    emits: ["scroll"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        // Keeps the menu below the fixed navigation bar ($navigation-bar-height + gap).
        const collisionPadding = { top: 64, right: 8, bottom: 8, left: 8 };
        const emit = __emit;
        const __returned__ = { collisionPadding, emit, get ComboboxPortal() { return ComboboxPortal; }, get ComboboxContent() { return ComboboxContent; }, get ComboboxViewport() { return ComboboxViewport; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
